module.exports = __webpack_public_path__ + "img/opa_lg.1bef396c.png";